import React from 'react'
import { IonModal } from '@ionic/react'
import { IonModalTypes } from '../../types'
import { ionHistory } from '../../../navigation'

import classNames from 'classnames'
import './styles.less'
import { getDirMode } from 'mobile_web/modules/platform'

const Modal: React.FC<IonModalTypes> = props => {
	const navigateWithNewState = (modalOpen: boolean) => {
		const historyState = {}
		Object.assign(historyState, ionHistory.location.state)
		const url = ionHistory.location.pathname + ionHistory.location.search + ionHistory.location.hash

		ionHistory.replace(url, { ...historyState, modalOpen })
	}

	return (
		<IonModal
			{...props}
			onDidPresent={event => {
				if (props.onDidPresent) {
					props.onDidPresent(event)
				}
				if (!props.preventNavigate) {
					navigateWithNewState(true)
				}
			}}
			onDidDismiss={event => {
				if (props.onDidDismiss) {
					props.onDidDismiss(event)
				}
				if (!props.preventNavigate) {
					navigateWithNewState(false)
				}
			}}
			className={classNames('app-modal', props.cssClass, `container-${getDirMode()}`)}
		>
			{props.children}
		</IonModal>
	)
}

export default Modal
